import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { installBrowserAutofillGuard } from "./lib/disableBrowserAutofill";
import { registerPwa, initOffline } from "./pwa";
import "./index.css";
import "./landing.css";

installBrowserAutofillGuard();
registerPwa();
void initOffline();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
